import { useState } from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Lockup, Star } from "../components/brand/Logo";
import { formatApiError, useAuth } from "./auth";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink px-5">
      <form onSubmit={submit} className="w-full max-w-sm" data-testid="admin-login-form">
        <div className="w-44 text-ivory"><Lockup className="w-full" /></div>
        <h1 className="mt-12 font-display text-4xl font-bold uppercase tracking-tight text-ivory">Studio inbox</h1>
        <p className="mt-2 text-sm text-mist">Owner access only.</p>
        <div className="mt-10 space-y-6">
          <div className="space-y-2">
            <Label htmlFor="em" className="label text-mist">Email</Label>
            <Input id="em" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="username"
              className="h-12 border-white/15 bg-char text-ivory" data-testid="admin-login-email" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="pw" className="label text-mist">Password</Label>
            <Input id="pw" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password"
              className="h-12 border-white/15 bg-char text-ivory" data-testid="admin-login-password" />
          </div>
          {error && <p className="text-sm text-[#ff8f8f]" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={busy} data-testid="admin-login-submit"
            className="label flex w-full items-center justify-center gap-2 rounded-full bg-lav py-4 text-ink transition-colors hover:bg-ivory disabled:opacity-60">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Star className="h-3.5 w-3.5" />}Sign in
          </button>
        </div>
      </form>
    </div>
  );
}
